// http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=806352220

import { post } from '@/lib/request/index';
import { entrega } from '../apiConstants';

// 闪送分享详情页
export function apiEntregaOrderDetail(param) {
  return post(entrega.ENTREAG_ORDER_DETAIL, { param });
}

// 获取号码保护的虚拟电话
export function apiEntregaGetVirtualtelCall(param) {
  return post(entrega.PROTECT_NUM_NO_LOGIN, {
    param
  })
}